import axios from "axios";

const prefix = import.meta.env.VITE_BE_HOST;

let appointmentAbortController = new AbortController();
export const apiGetAppointment = (appointmentId) => {
  appointmentAbortController.abort();
  appointmentAbortController = new AbortController();

  const token = localStorage.getItem("usr_token");

  const config = {
    headers: {
      "x-access-token": token?.replaceAll('"', ""),
    },
    params: {
      appointmentId,
    },
    signal: appointmentAbortController.signal,
  };

  return axios.get(prefix + `/calendar/appointment/${appointmentId}`, config);
};

export const apiPostAppointment = (appointmentData) => {
  const token = localStorage.getItem("usr_token");

  const config = {
    headers: {
      "x-access-token": token?.replaceAll('"', ""),
    },
  };

  return axios.post(prefix + `/calendar/appointment`, appointmentData, config);
};

export const apiUpdateAppointment = (appointmentId, appointmentData) => {
  const token = localStorage.getItem("usr_token");

  const config = {
    headers: {
      "x-access-token": token?.replaceAll('"', ""),
    },
  };

  return axios.put(
    prefix + `/calendar/appointment/${appointmentId}`,
    appointmentData,
    config,
  );
};
